export const formatErrorStatus = (error: string) => {
  return (
    error &&
    parseInt(error.split(' ').slice(0, 1).join(' '))
  );
};

export const formatErrorMessage = (error: string) => {
  return (
    error && typeof error === 'string' ?
    error.split(' ').slice(2).join(' ').replace(/"/g, '') : error
  );
};

